/**
 * Exact stock Yes report template used historically at create time.
 * First-release quality warnings match this string only (trimmed).
 */
export const STOCK_BINARY_POSITIVE_TEMPLATE = 'operator observed {prompt}';

/** Legacy negative auto-seed — must not be written by new editor toggles. */
export const STOCK_BINARY_NEGATIVE_TEMPLATE = 'operator observed {prompt} was not confirmed';

export const NARRATIVE_REVIEW_POLICY_VERSION = 1;

export function isExactStockBinaryPositiveTemplate(value: unknown): boolean {
  return String(value ?? '').trim() === STOCK_BINARY_POSITIVE_TEMPLATE;
}

export function expandReportPromptPlaceholder(
  template: string,
  promptText: unknown,
  title?: unknown,
): string {
  const prompt = String(promptText ?? '').replace(/\?+$/, '').trim();
  const titleText = String(title ?? '').trim();
  return String(template || '')
    .replace(/\{prompt\}/g, prompt)
    .replace(/\{title\}/g, titleText);
}
